<template>
  <el-dialog :title="$t('partnerPool.add')" :visible.sync="dialogVisible" width="70%" @close="closeDialog">
    <el-form label-width="120px">
      <el-form-item :label="$t('partnerPool.name')" required>
        <el-input v-model="addPartnerPoolInfo.partnerName" :placeholder="$t('partnerPool.requiredName')"></el-input>
      </el-form-item>

      <el-form-item :label="$t('partnerPool.partner')" required>
        <el-select v-model="addPartnerPoolInfo.partnerType" :placeholder="$t('partnerPool.requiredPartner')"
          style="width:100%" @change="_addChangeToType">
          <el-option v-for="(item, index) in addPartnerPoolInfo.partnerTypes" :key="index" :label="item.name"
            :value="item.partnerType"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item v-for="(item, index) in addPartnerPoolInfo.partnerKeys" :key="index" :label="item.name">
        <el-input type="textarea" v-model="item.columnValue" :placeholder="item.remark"></el-input>
      </el-form-item>

      <el-form-item :label="$t('partnerPool.usage')">
        <el-input type="textarea" v-model="addPartnerPoolInfo.remark"
          :placeholder="$t('partnerPool.optionalUsage')"></el-input>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="savePartnerPoolInfo">
        {{ $t('common.save') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { savePartnerPool, listPartnerKey, listPartnerAdapt } from '@/api/partner/partnerApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'AddPartnerPool',
  data() {
    return {
      dialogVisible: false,
      addPartnerPoolInfo: {
        partnerName: '',
        partnerType: '',
        state: 'Y',
        remark: '',
        partnerTypes: [],
        partnerKeys: []
      }
    }
  },
  methods: {
    open() {
      this._loadAddPartnerAdapt()
      this.dialogVisible = true
    },
    closeDialog() {
      this.dialogVisible = false
      this.clearAddPartnerPoolInfo()
    },
    async savePartnerPoolInfo() {
      if (!this.addPartnerPoolValidate()) {
        this.$message.error(this.$t('partnerPool.validateError'))
        return
      }

      this.addPartnerPoolInfo.shopId = getShopId()

      try {
        const res = await savePartnerPool(this.addPartnerPoolInfo)
        if (res.code === 0) {
          this.$message.success(this.$t('partnerPool.saveSuccess'))
          this.closeDialog()
          this.$emit('refresh')
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        this.$message.error(this.$t('partnerPool.saveFailed'))
      }
    },
    clearAddPartnerPoolInfo() {
      const partnerTypes = this.addPartnerPoolInfo.partnerTypes
      this.addPartnerPoolInfo = {
        partnerName: '',
        partnerType: '',
        partnerTypes: partnerTypes,
        partnerKeys: [],
        state: 'Y',
        remark: ''
      }
    },
    addPartnerPoolValidate() {
      if (!this.addPartnerPoolInfo.partnerName) {
        return false
      }
      if (!this.addPartnerPoolInfo.partnerType) {
        return false
      }
      return true
    },
    async _addChangeToType() {
      if (!this.addPartnerPoolInfo.partnerType) return

      try {
        const res = await listPartnerKey({
          partnerType: this.addPartnerPoolInfo.partnerType,
          page: 1,
          row: 100
        })
        this.addPartnerPoolInfo.partnerKeys = res.data.map(item => ({
          ...item,
          columnValue: ''
        }))
      } catch (error) {
        console.error('请求失败处理', error)
      }
    },
    async _loadAddPartnerAdapt() {
      try {
        const res = await listPartnerAdapt({
          page: 1,
          row: 100
        })
        this.addPartnerPoolInfo.partnerTypes = res.data
      } catch (error) {
        console.error('请求失败处理', error)
      }
    }
  }
}
</script>